import React, { forwardRef } from "react";
import "../MelaCheckbox/MelaCheckbox.css";
import "./MelaSwitch.css";

export interface MelaSwitchProps
  extends Omit<React.InputHTMLAttributes<HTMLInputElement>, "type" | "size"> {
  label?: React.ReactNode;
  /** Rendered under the control, aligned with the label text. */
  helperText?: React.ReactNode;
  containerClassName?: string;
  containerStyle?: React.CSSProperties;
  dataTestId?: string;
}

// The track (32px) plus the control gap (10px), so the helper lines up under the label.
const HELPER_INDENT = 42;

/** An on/off setting: a checkbox input with `role="switch"`. */
export const MelaSwitch = forwardRef<HTMLInputElement, MelaSwitchProps>(
  (
    {
      label,
      helperText,
      disabled = false,
      containerClassName,
      containerStyle,
      dataTestId,
      ...inputProps
    },
    ref,
  ) => (
    <div
      data-mela-check="true"
      className={containerClassName}
      style={containerStyle}
    >
      <label
        className={`mela-check__control ${disabled ? "mela-check__control--disabled" : ""}`}
      >
        <input
          {...inputProps}
          ref={ref}
          type="checkbox"
          role="switch"
          disabled={disabled}
          className="mela-check__input"
          data-testid={dataTestId}
        />
        <span className="mela-switch__track" aria-hidden="true">
          <span className="mela-switch__thumb" />
        </span>
        {label}
      </label>
      {helperText && (
        <span
          className="mela-check__helper"
          style={{ paddingLeft: HELPER_INDENT }}
        >
          {helperText}
        </span>
      )}
    </div>
  ),
);

MelaSwitch.displayName = "MelaSwitch";
